import { keyframes } from "styled-components";

export const imageFade = keyframes`
  0% {
    transform: translateY(-40px);
    opacity: 0;
  }
 
  100% {
    tranfrom:translateY(0px);
    opacity: 1;
  }
`;
